module.exports = __webpack_public_path__ + "img/customer_design_5.af54ce9.jpg";